import { useQuery, useMutation } from '@apollo/client/react'
import {
  GET_OUTREACH_QUEUE,
  APPROVE_OUTREACH_ITEM,
  REJECT_OUTREACH_ITEM,
} from '@/lib/operations/providers'
import type { OutreachQueueItem } from '@/lib/types'

// ─── Read hook ────────────────────────────────────────────────────────────────

export function useOutreachQueue(clientId: string) {
  const { data, loading, error } = useQuery<{ outreachQueue: OutreachQueueItem[] }>(
    GET_OUTREACH_QUEUE,
    {
      variables: { clientId, status: 'pending_review' },
      skip: !clientId,
    },
  )
  return { items: data?.outreachQueue ?? [], loading, error }
}

// ─── Mutation hooks ───────────────────────────────────────────────────────────

export function useApproveOutreachItem() {
  const [mutate, { loading }] = useMutation<{ approveOutreachItem: OutreachQueueItem | null }>(
    APPROVE_OUTREACH_ITEM,
  )
  const approveOutreachItem = (clientId: string, itemId: string) =>
    mutate({
      variables: { clientId, itemId },
      refetchQueries: [{ query: GET_OUTREACH_QUEUE, variables: { clientId, status: 'pending_review' } }],
    })
  return { approveOutreachItem, loading }
}

export function useRejectOutreachItem() {
  const [mutate, { loading }] = useMutation<{ rejectOutreachItem: OutreachQueueItem | null }>(
    REJECT_OUTREACH_ITEM,
  )
  const rejectOutreachItem = (clientId: string, itemId: string, reason?: string) =>
    mutate({
      variables: { clientId, itemId, reason },
      refetchQueries: [{ query: GET_OUTREACH_QUEUE, variables: { clientId, status: 'pending_review' } }],
    })
  return { rejectOutreachItem, loading }
}
